import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useContent from '../hooks/useContent';
import useMedia from '../hooks/useMedia';
import useSettings from '../hooks/useSettings';

export default function Dashboard() {
  const [contentItems, setContentItems] = useState([]);
  const [mediaItems, setMediaItems] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const contentApi = useContent();
  const mediaApi = useMedia();
  const settingsApi = useSettings();

  useEffect(() => {
    const loadData = async () => {
      try {
        const [contentRes, mediaRes, settingsRes] = await Promise.all([
          contentApi.listContent({ limit: 100 }),
          mediaApi.listMedia({ limit: 100 }),
          settingsApi.getSettings(),
        ]);
        setContentItems(contentRes.items || []);
        setMediaItems(mediaRes.items || []);
        setSettings(settingsRes);
      } catch (err) {
        console.error('Failed to load dashboard data:', err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const recentContent = contentItems.slice(0, 5);
  const drafts = contentItems.filter((item) => item.status === 'draft').length;

  return (
    <div className="stack gap-lg">
      <section className="stats-grid">
        <div className="stat-card"><span>Total content</span><strong>{loading ? '…' : contentItems.length}</strong></div>
        <div className="stat-card"><span>Drafts</span><strong>{loading ? '…' : drafts}</strong></div>
        <div className="stat-card"><span>Media assets</span><strong>{loading ? '…' : mediaItems.length}</strong></div>
        <div className="stat-card"><span>Last publish</span><strong>{loading ? '…' : (settings?.lastPublishAt || 'Never')}</strong></div>
      </section>
      <section className="card">
        <h2>Quick actions</h2>
        <div className="button-row">
          <Link className="button primary" to="/content/new">New page</Link>
          <Link className="button primary" to="/content/new?type=post">New post</Link>
          <Link className="button secondary" to="/media">Upload media</Link>
          <Link className="button secondary" to="/publish">Publish site</Link>
        </div>
      </section>

      <section className="card">
        <h2>Recently updated</h2>
        {recentContent.length === 0 ? (
          <p className="muted">No content yet.</p>
        ) : (
          <ul className="recent-list">
            {recentContent.map((item) => (
              <li key={item.contentId} className="recent-item">
                <Link to={`/content/${item.contentId}`} className="recent-link">
                  <span className="recent-title">{item.title}</span>
                  <span className="muted small">{item.contentType} • {item.status}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
